import { useCallback } from "react"
import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"

export type TrackingEventProperties = Record<string, string>

type TrackingEventRequest = {
  screen: string
  event: string
  page: string
  properties: TrackingEventProperties
}

export function useWoopraAPI() {
  const request = useAxiosRequest()

  const postTrackingEvent = useCallback(
    async function postTrackingEvent({
      page,
      event,
      properties,
    }: {
      page: string
      event: string
      properties: TrackingEventProperties
    }) {
      return request<TrackingEventRequest, unknown>({
        url: `${BASE_URL}/tracking/events`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: {
          screen: window.screen.width + "x" + window.screen.height,
          event,
          page,
          properties,
        },
      })
    },
    [request]
  )

  return { postTrackingEvent }
}
